// extracted by mini-css-extract-plugin
export default {"box":"TicketsStatus_box__ZZRCR","content":"TicketsStatus_content__ZZlXU","donut":"TicketsStatus_donut__+lVDf"};